import { FlexContainer } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

const SidebarStyled = styled(FlexContainer)<{ isOpen: boolean }>(({ isOpen }) => {
  return `
    width: ${isOpen ? 400 : 0}px;
    height: calc(100vh - 42px);
    position: fixed;
    top: 21px;
    left: 21px;
    background-color: white;
    box-shadow: 0px 8px 24px rgba(34, 34, 34, 0.15);
    border-radius: 8px;
    transition: all 0.33s;
  `
})

export default SidebarStyled
